import React, { Suspense } from "react"
import { Outlet } from "react-router-dom"
import { CircularProgress } from "@mui/material"
import AccountNav from "./AccountNav"
import AccountSidebar from "./AccountSidebar"
import AirtagFooter from "src/pages/landing/components/AirtagFooter"

// Persistent layout route for the account/profile section. Renders the chrome
// (nav + sidebar + footer) ONCE and swaps only the page via <Outlet/>, so
// clicking a sidebar item changes just the content area — the chrome stays
// mounted (no flicker, no full-screen reload, nav fetches fire once). The inner
// <Suspense> scopes the lazy page-chunk fallback to the content column.
const ContentLoading = () => (
    <div style={{ display: "flex", justifyContent: "center", padding: "80px 0" }}>
        <CircularProgress sx={{ color: "#7c3aed" }} />
    </div>
)

export default function ProfileShell() {
    return (
        <div className="acct">
            <AccountNav />
            <div className="acct-wrap">
                <AccountSidebar />
                <Suspense fallback={<ContentLoading />}>
                    <Outlet />
                </Suspense>
            </div>
            <AirtagFooter />
        </div>
    )
}
